import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import qs from 'query-string'
import template from 'es6-dynamic-template'

import errors from 'common/config/messages.json'
import {Vector} from '../base/Elements'

export class Messenger extends React.Component {
    static childContextTypes = {
        messenger: PropTypes.object
    }

    state = {
        message: null
    }

    componentWillMount() {
        const params = qs.parse(window.location.search);
        const { error } = params;

        if (error) {
            this.publish(error, 'Query');
        }
    }


  publish = (code, namespace, type) => {
    let message = this.errorByCode(`${namespace}.${type}.${code}`);
    message = message || this.errorByCode(`${namespace}.${code}`);

    console.log(code, namespace, type);

    if (code != 'Success')
      message = message || this.errorByCode('Error');

    this.setState({message: message});
  }

  errorByCode = (code) => (errors[code])

  onDismiss = () =>
    this.setState({message: null});

  getChildContext() {
    return { messenger: { publish: this.publish } };
  }

  render() {
    const { children } = this.props;
    const { message } = this.state;

    return (
      <React.Fragment>
        {message != null
            && <ErrorMessage content={message} onClick={this.onDismiss} />}

        {children}
      </React.Fragment>
    );
  }
};

class ErrorMessage extends React.Component {
  icons = {
    success: 'success_happy_smile',
    warn: 'attantion_confuse_smile',
    error: 'error_sad_smile'
  }

  componentDidMount() {
    window.document.addEventListener('click', this.onDocumentClick);
  }

  componentWillUnmount() {
    window.document.removeEventListener('click', this.onDocumentClick);
  }

  onDocumentClick = (ev) => {
    const elem = ReactDOM.findDOMNode(this.area);

    if (elem && !elem.contains(ev.target))
      this.setState({message: null});
  }

  render() {
    const {content, onClick} = this.props;
    const icon = this.icons[content.type];

    return (
      <div className="message__wrap">
        <div className="message__item" ref="item">
          <div className="message__item-wrap">
            <div className={`message__emojis ${content.type}`}>
              <Vector className="message__emoji" src={icon} alt="" />
            </div>
            <div className="message__content">
              <h3 className="message__title">{content.title}</h3>
              <p className="message__text">{content.content}</p>
            </div>
          </div>
          <a className="message__close is-clickable" onClick={onClick}>
            <Vector src="cancel-icon" alt="" />
          </a>
        </div>
      </div>
    );
  }
}
